import {Component, Inject, Optional, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-adx-invoice-details-modal',
    templateUrl: './adx-invoice-details-modal.component.html',
    standalone: false
})
export class AdxInvoiceDetailsModalComponent implements OnInit {
  title: string;
  adxInvoiceId: any;

  constructor(
    @Optional() public dialogRef: MatDialogRef<AdxInvoiceDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string, adxInvoiceId: number },
    public dialog: MatDialog
  ) {
    this.title = data.title;
    this.adxInvoiceId = data.adxInvoiceId;
  }

  ngOnInit(): void {
    if (!this.data) {
      console.error('Data is missing');
    }
  }

  public closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close(false);
    }
  }
}
